import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { Link } from '../Link'
import { Text } from '../Text'
import { Stack } from '../Stack'
// import { GraphQLImage } from '../GraphQLImage'

import { GuildPrimaryPhoto } from './GuildPrimaryPhoto'

import { GuildMembershipStatus } from './GuildMembershipStatus'

import { GuildItem_guild$key } from './__generated__/GuildItem_guild.graphql'

export const GuildItem: FC<{
  guild: GuildItem_guild$key
  displayMembershipStatus?: boolean
  textSize?: number
  photoSize?: number
  nameOnly?: boolean
}> = ({
  guild,
  displayMembershipStatus = true,
  textSize = 5,
  photoSize = 10,
  nameOnly = false,
}) => {
  const data = useFragment(
    graphql`
      fragment GuildItem_guild on Guild
      @argumentDefinitions(
        displayMembershipStatus: { type: "Boolean!", defaultValue: true }
      ) {
        slugId
        name

        ...GuildMembershipStatus_guild
          @arguments(displayMembershipStatus: $displayMembershipStatus)

        ...GuildPrimaryPhoto_guild
      }
    `,
    guild
  )

  return (
    <Link to={`/${data.slugId}`}>
      <Stack direction='horizontal' gap={3} alignItems={'center'}>
        <GuildPrimaryPhoto guild={data} size={photoSize} />

        <Stack gap={1} variant='wrap'>
          <Text numberOfLines={1} size={textSize}>
            {data.name}
          </Text>

          {!nameOnly && (
            <GuildMembershipStatus
              guild={data}
              displayMembershipStatus={displayMembershipStatus}
            />
          )}
        </Stack>
      </Stack>
    </Link>
  )
}
